import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Card(_: Props) {
  return (
    <div className={styles.card}>
      <div className={styles.body}>
        <div className={styles.author}>
          <Skeleton className={styles.avatar} />
        </div>
        <Skeleton className={styles.content} />
      </div>
      <Skeleton className={styles.date} />
    </div>
  );
}

export { Card };
